import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight, Star, Download } from 'lucide-react';
import { Link } from 'react-router-dom';

const Success: React.FC = () => {
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="max-w-lg w-full bg-white/5 border border-white/10 p-12 rounded-3xl text-center relative overflow-hidden"
      >
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-64 bg-gold/10 blur-[80px] rounded-full -mt-32" />
        
        <div className="relative z-10">
          <div className="w-20 h-20 bg-gold rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg shadow-gold/20">
            <CheckCircle2 className="w-10 h-10 text-midnight" />
          </div>
          
          <h1 className="text-4xl font-serif font-bold mb-4">Order Confirmed!</h1>
          <p className="text-gray-400 mb-8">
            The stars have aligned. Your order has been successfully placed and is being processed by our celestial team.
          </p>

          <div className="bg-white/5 border border-white/10 rounded-2xl p-6 mb-8 text-left space-y-4">
            <div className="flex justify-between items-center">
              <span className="text-xs text-gray-500 uppercase tracking-widest">Order ID</span>
              <span className="text-sm font-bold text-white">#AS-2026-8842</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-xs text-gray-500 uppercase tracking-widest">Status</span>
              <span className="text-xs font-bold text-gold bg-gold/10 px-2 py-1 rounded-full">Processing</span>
            </div>
          </div>

          <div className="space-y-4">
            <Link
              to="/"
              className="w-full py-4 bg-gold text-midnight font-bold rounded-xl hover:bg-white transition-all flex items-center justify-center group"
            >
              Return to Home
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
            <button className="w-full py-4 bg-white/5 border border-white/20 text-white font-bold rounded-xl hover:bg-white/10 transition-all flex items-center justify-center">
              <Download className="w-5 h-5 mr-2" />
              Download Invoice
            </button>
          </div>

          <div className="mt-12 flex items-center justify-center space-x-2 text-gold">
            <Star className="w-4 h-4 fill-gold" />
            <span className="text-xs font-bold uppercase tracking-[0.2em]">AstroVidya.net</span>
            <Star className="w-4 h-4 fill-gold" />
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default Success;
